import { sendAsyncAction } from '../../core/async.js';

var SteamUserRestrictions;
(function (SteamUserRestrictions) {
    SteamUserRestrictions[SteamUserRestrictions["NONE"] = 0] = "NONE";
    SteamUserRestrictions[SteamUserRestrictions["UNKNOWN"] = 1] = "UNKNOWN";
    SteamUserRestrictions[SteamUserRestrictions["ANY_CHAT"] = 2] = "ANY_CHAT";
    SteamUserRestrictions[SteamUserRestrictions["VOICE_CHAT"] = 4] = "VOICE_CHAT";
    SteamUserRestrictions[SteamUserRestrictions["GROUP_CHAT"] = 8] = "GROUP_CHAT";
    SteamUserRestrictions[SteamUserRestrictions["RATING"] = 16] = "RATING";
    SteamUserRestrictions[SteamUserRestrictions["GAME_INVITES"] = 32] = "GAME_INVITES";
    SteamUserRestrictions[SteamUserRestrictions["TRADING"] = 64] = "TRADING";
})(SteamUserRestrictions || (SteamUserRestrictions = {}));
function getUserRestrictions() {
    return sendAsyncAction({
        actionId: 'getUserRestrictions',
    });
}

export { SteamUserRestrictions, getUserRestrictions };
//# sourceMappingURL=getUserRestrictions.js.map
